//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
(function () {

    angular
        .module('container.widgets')
        .directive('srsngNotification', srsngNotification);

    function srsngNotification() {
        return {
            restrict: 'E',
            templateUrl: 'container/ui/app/widgets/notification/notification.html',
            scope: {},
            controller: controller,
            link: link
        };

        function controller($rootScope, $scope, $timeout, $filter) {
            $scope.notificationContext = { visible: false, type: "success", text: "" };
            $scope.close = close;
            $scope.inner = false;

            $rootScope.$on('displayError', function (event, message, error) {
                if ($scope.inner) return;

                var errorText = '';
                if (error) {
                    if (error.data) {
                        if (error.data.error && error.data.error !== "") {
                            errorText = error.data.error;
                        }
                        if (errorText == '' && error.data.message && error.data.message !== "") {
                            errorText = `${$filter('translate')(error.data.message)}`;
                        }
                        if(error.data.correlationId && error.data.correlationId != "") {
                            errorText += ` - CorrelationId: ${error.data.correlationId}`;
                        }
                        if(errorText == '') {
                            errorText = error.data;
                        }

                    } else {
                        errorText = error.statusText;
                    }
                }
                console.log("displayError: ", errorText);
                $scope.notificationContext = { visible: true, type: "error", text: $filter('translate')(message), error: errorText };
                event.stopPropagation();
            });

            $rootScope.$on('displaySuccess', function (event, message) {
                if ($scope.inner) return;
                console.log("displaySuccess: ", message);

                $scope.notificationContext = { visible: true, type: "success", text: $filter('translate')(message) };
                $timeout(function () {
                    close();
                }, 10000);
                event.stopPropagation();
            });

            $rootScope.$on('displayInnerError', function (event, message, error) {
                if (!$scope.inner) return;

                var errorText = '';
                if (error) {
                    if (error.data) {
                        if (error.data.error && error.data.error !== "") {
                            errorText = error.data.error;
                        }
                        if (errorText == '' && error.data.message && error.data.message !== "") {
                            errorText = `${$filter('translate')(error.data.message)}`;
                        }
                        if(error.data.correlationId && error.data.correlationId != "") {
                            errorText += ` - CorrelationId: ${error.data.correlationId}`;
                        }
                        if(errorText == '') {
                            errorText = error.data;
                        }
                    } else {
                        errorText = error;
                    }
                }
                console.log("displayInnerError: ", errorText);
                $scope.notificationContext = { visible: true, type: "error", text: $filter('translate')(message), error: errorText };
                event.stopPropagation();
            });

            $rootScope.$on('displayInnerSuccess', function (event, message) {
                if (!$scope.inner) return;

                $scope.notificationContext = { visible: true, type: "success", text: $filter('translate')(message) };
                $timeout(function () {
                    close();
                }, 2000);
                event.stopPropagation();
            });

            $rootScope.$on('closeNotification', function (event) {
                close();
                event.stopPropagation();
            });

            function close() {
                $scope.notificationContext.visible = false;
            }

        }

        function link(scope, element, attrs) {
            if ("inner" in attrs) scope.inner = true;
            else scope.inner = false;

        }

    }

} ());
